import VTreeSelect from './VTreeSelect'

export { VTreeSelect }
export default VTreeSelect
